<template>
  <div>
    <div class="component-title">
      <div class="component-title">
        <h1 class="">Financial Capacity</h1>
      </div>
    </div>

    <div>
      <form id="form10" autocomplete="off" class="mt-40">
        <div class="row Introduce-yourself-container" style="font-size: 18px">
          <div class="row pt-10">
            <div class="col-sm-6 col-md-6">
              <span>Marital Status</span>
              <select required="" name="marital_status">
                <option selected="selected" value="">Select</option>
                <option value="Married">Married</option>
                <option value="Defacto">Defacto</option>
                <option value="Single">Single</option>
              </select>
            </div>
            <div class="col-sm-6 col-md-6 financecapacity">
              <div class="flx justify-content-between align-items-center">
                <span>Number of Dependants</span>
                <div class="help-icon">
                  <img
                    src="https://mps.ccfunding.com.au/images/help-icon.png"
                    class="img-100"
                  />
                  <span
                    class="question-tips"
                    style="
                      z-index: 12;
                      bottom: -22vw;
                      width: 24vw;
                      right: -1.5vw;
                    "
                    >A person can be considered your dependant if they meet the
                    criteria for one of the categories. It can be your spouse,
                    your child, any other person you are in an interdependent
                    relationship with, or a person who is substantially
                    financially dependent on you.
                  </span>
                </div>
              </div>
              <select required="" name="no_of_dependants">
                <option selected="selected" value="">Select</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
            </div>
          </div>

          <div class="row pt-10">
            <div class="col-sm-6 col-md-6">
              <span>How many children do you have?</span>
              <select id="no_of_children" required="" name="no_of_children">
                <option selected="selected" value="">Select</option>
                <option value="0">0</option>
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
              </select>
            </div>
            <div class="col-sm-6 col-md-6">
              <p class="m-0 none" id="children_question" style="font-size: 20px">
                Please enter your children's ages:
              </p>
              <div class="" id="childrendiv"></div>
            </div>
          </div>

          <div class="reason-info pt-20 flx align-items-center">
            <p class="col-sm-6 pl-0" style="text-align: left; font-size: 20px">
              Are you the sole income earner in the household
            </p>
            <div class="col-sm-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="sole_income_earner"
                  value="1"
                  id="soleIncomeEarner_yes"
                  required=""
                />
                <label class="default" for="soleIncomeEarner_yes">Yes</label>
                <input
                  type="radio"
                  name="sole_income_earner"
                  value="0"
                  id="soleIncomeEarner_no"
                  required=""
                />
                <label class="default" for="soleIncomeEarner_no">No</label>
              </div>
              <label
                id="soleIncomeEarner-error"
                class="error"
                for="soleIncomeEarner"
              ></label>
            </div>
          </div>

          <div class="pt-20 flx align-items-center">
            <p class="col-sm-6 pl-0" style="text-align: left; font-size: 20px">
              Would you be able to maintain your commitments & lifestyle if you or your partner were unable to earn an income?
            </p>
            <div class="col-sm-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="partner_income_earner"
                  value="1"
                  id="partnerIncomeEarner_yes"
                  required=""
                />
                <label class="default" for="partnerIncomeEarner_yes">Yes</label>
                <input
                  type="radio"
                  name="partner_income_earner"
                  value="0"
                  id="partnerIncomeEarner_no"
                  required=""
                />
                <label class="default" for="partnerIncomeEarner_no">No</label>
              </div>
              <label
                id="partnerIncomeEarner-error"
                class="error"
                for="partnerIncomeEarner"
              ></label>
            </div>
          </div>

          <div class="pt-20 flx align-items-center">
            <p class="col-sm-6 pl-0" style="text-align: left; font-size: 20px">
              Do you have a will?
            </p>
            <div class="col-sm-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="have_will"
                  value="1"
                  id="haveWill_yes"
                  required=""
                />
                <label class="default" for="haveWill_yes">Yes</label>
                <input
                  type="radio"
                  name="have_will"
                  value="0"
                  id="haveWill_no"
                  required=""
                />
                <label class="default" for="haveWill_no">No</label>
              </div>
              <label
                id="haveWill-error"
                class="error"
                for="haveWill"
              ></label>
            </div>
          </div>

          <div class="pt-20 flx align-items-center">
            <p class="col-sm-6 pl-0" style="text-align: left; font-size: 20px">
              Do you have adequate insurance to meet your loan repayments in the event your are unable to work? (e.g. life insurance, loan protection insurance, income protection insurance)
            </p>
            <div class="col-sm-6 flx align-items-end">
              <div class="toggle">
                <input
                  type="radio"
                  name="adequate_insurance"
                  value="1"
                  id="adequateInsurance_yes"
                  required=""
                />
                <label class="default" for="adequateInsurance_yes">Yes</label>
                <input
                  type="radio"
                  name="adequate_insurance"
                  value="0"
                  id="adequateInsurance_no"
                  required=""
                />
                <label class="default" for="adequateInsurance_no">No</label>
              </div>
              <label
                id="adequateInsurance-error"
                class="error"
                for="adequateInsurance"
              ></label>
            </div>
          </div>

          <p class="mt-20"><b>Next of Kin Details</b></p>

          <div class="row pt-10">
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered first name</span>
              <input type="text" id="FirstName" class="" required="" autofocus="">
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered middle name</span>
              <input type="text" id="MiddleName" class="" autofocus="">
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Registered last name</span>
              <input type="text" id="LastName" class="" required="" autofocus="">
            </div>
            <div class="col-sm-4 col-md-4 mt-10">
              <span>Mobile Number</span>
              <input type="text" id="MobileNumber" class="" required="" autofocus="">
            </div>
            <div class="col-sm-6 col-md-6 mt-10">
              <span>Next of Kin Relationship</span>
              <select required="" name="marital_status">
                <option selected="selected" value="">Select</option>
                <option value="Father">Father</option>
                <option value="Mother">Mother</option>
                <option value="Partner">Partner</option>
              </select>
            </div>
          </div>

        </div>
      </form>
    </div>

    <div class="flx loan-container mt-60">
      <a
        type="button"
        class="continue-btn continue-btn-small steps-btn"
        href="#"
        @click.prevent="onContinue('financial-capacity')"
        >BACK</a
      >
      <a
        type="button"
        class="continue-btn continue-btn-small continue-btn-small-right steps-btn"
        href="#"
        @click.prevent="onContinue('financial-assets')"
        >CONTINUE</a
      >
    </div>
    <div class="mt-60 clear"></div>
  </div>
</template>

<script>
export default {
  props: ["onChangeStep"],
  methods: {
    onContinue(step) {
      this.onChangeStep(step);
    },
  },
};
</script>
